import constants from "../utils/constants";
import TokenNeeded from "../utils/TokenNeeded";

class BalootUserController {
  static sync() {
    return TokenNeeded.request({
      method: "get",
      url: constants.baloot.userController + "sync",
    });
  }

  static wallet() {
    return TokenNeeded.request({
      method: "get",
      url: constants.baloot.userController + "wallets/my",
    });
  }

  static walletTransactions(data) {
    return TokenNeeded.request({
      method: "get",
      url: constants.baloot.userController + "wallets/transactions",
      params: {
        page: data.page,
        size: data.size || 20,
      },
    });
  }

  static getSubscription(data) {
    return TokenNeeded.request({
      method: "get",
      url: constants.baloot.userController + "recurring/subscriptions",
    });
  }

  static setSubscription(data) {
    return TokenNeeded.request({
      method: "post",
      url: constants.baloot.userControllerV2 + "recurring/subscriptions",
      params: {
        bankId: data.bankId,
        day: data.day,
        limit: data.limit,
        period: data.period,
        mobile: data.mobile,
      },
    });
  }

  static setPreSubscription(data) {
    return TokenNeeded.request({
      method: "get",
      url: constants.baloot.userController + "recurring/subscriptions/pre",
      params: {
        bankId: data.bankId,
        day: data.day,
        limit: data.limit,
        period: data.period,
      },
    });
  }

  static deleteSubscription(data) {
    return TokenNeeded.request({
      method: "delete",
      url:
        constants.baloot.userController +
        "recurring/subscriptions/" +
        data.id.toString(),
    });
  }

  static getBanks() {
    return TokenNeeded.request({
      method: "get",
      url: constants.baloot.userController + "recurring/banks/",
    });
  }

  static getUserContract() {
    return TokenNeeded.request({
      method: "get",
      url: constants.baloot.userController + "recurring/contracts",
    });
  }

  static deleteUserContract(data) {
    return TokenNeeded.request({
      method: "delete",
      url:
        constants.baloot.userController +
        "recurring/contracts/" +
        data.id.toString(),
    });
  }

  static getAutoInvestmentStatus() {
    return TokenNeeded.request({
      method: "get",
      url: constants.baloot.userController + "autoinvestment",
    });
  }

  static setAutoInvestmentState(data) {
    return TokenNeeded.request({
      method: "patch",
      url: constants.baloot.userController + "autoinvestment",
      params: {
        enable: data.enabled,
      },
    });
  }

  static getAutoInvestmentFunds() {
    return TokenNeeded.request({
      method: "get",
      url: constants.baloot.userController + "autoinvestment/funds",
    });
  }

  static addAutoInvestmentItems(data) {
    return TokenNeeded.request({
      method: "put",
      url: constants.baloot.userController + "autoinvestment/items",
      data: data.items,
    });
  }

  static deleteAutoInvestmentItem(data) {
    return TokenNeeded.request({
      method: "delete",
      url:
        constants.baloot.userController +
        "autoinvestment/items/" +
        data.id.toString(),
    });
  }

  static getUserInvestmentHistory(data) {
    return TokenNeeded.request({
      method: "get",
      url: constants.baloot.userController + "investments/stats/past",
      params: {
        page: data.page || 0,
        size: data.size || 20,
      },
    });
  }

  static getUserInvestmentToday(data) {
    return TokenNeeded.request({
      method: "get",
      url: constants.baloot.userController + "investments/stats/today",
    });
  }

  static getFinancialAssets(data) {
    return TokenNeeded.request({
      method: "get",
      url: constants.baloot.userController + "investments/financial-assets",
      params: {
        page: data.page || 0,
        size: data.size || 20,
      },
    });
  }

  static getFinancialAsset(data) {
    return TokenNeeded.request({
      method: "get",
      url:
        constants.baloot.userController +
        "investments/financial-assets/" +
        data.assetId.toString(),
    });
  }

  static invest(data) {
    return TokenNeeded.request({
      method: "put",
      url:
        constants.baloot.userController +
        "investments/" +
        data.assetId.toString() +
        "/invest",
      params: {
        amount: data.amount,
      },
    });
  }

  static getFinancialAssetSellPre(data) {
    return TokenNeeded.request({
      method: "get",
      url:
        constants.baloot.userController +
        "investments/" +
        data.assetId.toString() +
        "/sell/pre",
    });
  }

  static sendFinancialAssetSellOTP(data) {
    return TokenNeeded.request({
      method: "put",
      url:
        constants.baloot.userController +
        "investments/" +
        data.assetId.toString() +
        "/sell/otp",
    });
  }

  static confirmFinancialAssetSellOTP(data) {
    return TokenNeeded.request({
      method: "put",
      url:
        constants.baloot.userController +
        "investments/" +
        data.assetId.toString() +
        "/sell",
      params: {
        units: data.units,
        otp: data.otp,
      },
    });
  }

  static preCashoutInfo(data) {
    return TokenNeeded.request({
      method: "get",
      url:
        constants.baloot.userController +
        "wallets/" +
        data.walletId.toString() +
        "/withdrawal/pre",
    });
  }

  static cashout(data) {
    return TokenNeeded.request({
      method: "put",
      url:
        constants.baloot.userController +
        "wallets/" +
        data.walletId.toString() +
        "/withdrawal",
      params: {
        amount: data.amount,
      },
    });
  }

  static updateIban(data) {
    return TokenNeeded.request({
      method: "put",
      url: constants.baloot.userController + "account/bank",
      params: {
        iban: data.iban,
      },
    });
  }

  static getUserAccount(data) {
    return TokenNeeded.request({
      method: "get",
      url: constants.baloot.userController + "account",
    });
  }

  static updatePersonalInfo(data) {
    return TokenNeeded.request({
      method: "put",
      url: constants.baloot.userController + "account/personal",
      data: {
        birthDate: data.birthDate,
        firstName: data.firstName,
        lastName: data.lastName,
        nationalId: data.nationalId,
      },
    });
  }

  static savePersonalInfo(data) {
    return TokenNeeded.request({
      method: "post",
      url: constants.baloot.userController + "account/personal",
      data: {
        firstName: data.firstName,
        lastName: data.lastName,
      },
    });
  }

  static getUserSejamStatus() {
    return TokenNeeded.request({
      method: "get",
      url: constants.baloot.userController + "profile/status",
    });
  }

  static accountSetupStep() {
    return TokenNeeded.request({
      method: "get",
      url: constants.baloot.userController + "account-setup/steps",
    });
  }
}

export default BalootUserController;
